
export const excelConfig = {
    columns: [],
    fileName: `Excel_Export.xlsx`,
    headerRowStyle: {
        font: {
            name: 'Calibri',
            family: 2,
            size: 11,
            bold: true,
            color: { argb: '00000000' },
        },
        alignment: { vertical: 'middle' },
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ffffffff' },
            bgColor: { argb: 'ffffffff' }
        }
    },
    borderStyle: {
        top: { style: 'thin', color: { argb: 'FFBDBDBD' } },
        left: { style: 'thin', color: { argb: 'FFBDBDBD' } },
        bottom: { style: 'thin', color: { argb: 'FFBDBDBD' } },
        right: { style: 'thin', color: { argb: 'FFBDBDBD' } }
    },
    pageSetup: {
        paperSize: 9,
        orientation: 'landscape',
        margins: {
            left: 0.5, right: 0.1, top: 0.4, bottom: 0.3, header: 0.1, footer: 0.1
        },
        fitToPage: true,
        fitToHeight: 0
    },
    defaultHeaderRowHeight: 20,
    defaultDataRowHeight: 20,
    showFilterSection: false,
    filterSectionData: null,
    workSheetTitle: 'Sheet 1',
    headerFooter: {
        firstHeader: null,
        firstFooter: null
    }
}

export const filterHeaderXlStyle = {
    alignment:{ vertical:'middle',horizontal:'left'},
    font:{ ame:'Calibri', family:2, size:12, bold:true, color: { argb: 'FFFFFFFF' },},
    fill:{ type:'pattern', pattern:'solid', fgColor:{argb:'FF1E59A7'}, bgColor:{argb:'FF1E59A7'}},
    defaultRowHeight: 24
};

export const filterHeaderXlDataStyle = {
    alignment:{ vertical:'middle',horizontal:'left'},
    font:{ ame:'Calibri', family:2, size:12, bold:false},
    defaultRowHeight: 24
}